import { render, staticRenderFns } from "./MessagingView.vue?vue&type=template&id=0c742502&"
import script from "./MessagingView.vue?vue&type=script&lang=js&"
export * from "./MessagingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports